import { lazy } from 'react';
import { authRoles } from '@/app/auth';

const ReferralInvitePage = lazy(() => import('./ReferralInvitePage'));

const ReferralInviteConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: 'invitation/:token',
      element: <ReferralInvitePage />,
    },
  ],
};

export default ReferralInviteConfig;
